export default __webpack_public_path__ + "static/O0139-4e955ee34e16e4e8b0dc8c7f87cd52fb.png";